// extracted by mini-css-extract-plugin
export var showAllItems = "workItems-module--showAllItems--k8cHj";
export var workContent = "workItems-module--workContent--CSJsy";
export var workContentItem = "workItems-module--workContentItem--6SiO6";
export var workContentItemDescription = "workItems-module--workContentItemDescription--CIL8G";
export var workContentItemImage = "workItems-module--workContentItemImage--yg2OY";
export var workContentItemLocation = "workItems-module--workContentItemLocation--3MsL4";
export var workContentItemName = "workItems-module--workContentItemName--y-ZcV";
export var workList = "workItems-module--workList--HTogR";
export var workListItem = "workItems-module--workListItem--sjLE1";